export default function isAlertVisible(achType, schedule) {
  if (achType !== 'automatic') {
    return false;
  }

  // Convert each percent value to an integer representing its hundredths value
  const percentSumCents = schedule.reduce((acc, { percent }) => {
    // Multiply by 100 to work with integers, and round to avoid any residual floating-point issues
    const value = percent ? Math.round(parseFloat(percent) * 100) : 0;
    return acc + value;
  }, 0);

  // If the total in hundredths is not exactly 10000, then it's not exactly 100.00
  if (percentSumCents !== 10000) {
    return true;
  }

  return false;
}
